import { UPDATE_RENDER_PREVIEW } from '../config/constant/apiConstant';
import {
  setFilterData,
  setFiltersFetchedOnce,
  updateFilter,
  updateFilterLoading,
} from '../redux/slicers/filters/filterSlicer';
import { paginatedRenderPreviewsActions } from '../redux/slicers/admin/paginatedRenderPreviewsSlicer';
import { apiCreateFilterOption, apiCreateGlobalTag, apiGetFilters } from '../helpers/api';
import { myRenderPreviewActions } from '../redux/slicers/render_preview/myRenderPreviewSlice';
import { fetchAllPages } from '../helpers/apiHelper';
import { createDeleteApiAction, createUpdateApiAction } from './apiGenerator';

export const RenderPreviewEditApi = createUpdateApiAction({
  actions: paginatedRenderPreviewsActions,
  endpointUrl: UPDATE_RENDER_PREVIEW,
});

export const deleteRenderPreviewAPI = createDeleteApiAction({
  actions: paginatedRenderPreviewsActions,
  endpointUrl: UPDATE_RENDER_PREVIEW,
  successMessage: 'Deleted',
});

export const deleteMyRenderPreviewAPI = createDeleteApiAction({
  actions: myRenderPreviewActions,
  endpointUrl: UPDATE_RENDER_PREVIEW,
  successMessage: 'Deleted',
  optimistic: false,
});

export const updateMyRenderPreviewApi = createUpdateApiAction({
  actions: myRenderPreviewActions,
  endpointUrl: UPDATE_RENDER_PREVIEW,
});

// Filter APIs
export const getFiltersApi = () => async (dispatch) => {
  const result = await fetchAllPages((page) => {
    return apiGetFilters({ perPage: 20, page });
  });

  if (result?.results) {
    dispatch(setFilterData(result));
    setTimeout(() => {
      dispatch(setFiltersFetchedOnce(true));
    }, 5000); // add timeout in case if someone tries to load filters right away it prevent double api calls
  }
};

window.getFiltersApi = getFiltersApi;

export const addFilterOptionApi =
  ({ filterType, filterId, filterName, optionName }) =>
  async (dispatch) => {
    dispatch(
      updateFilterLoading({
        filterType,
        filterName,
        loading: true,
      })
    );

    const result = await apiCreateFilterOption({
      filterId,
      options: [optionName],
    });

    if (result?.id) {
      dispatch(updateFilter(result));
    }

    dispatch(
      updateFilterLoading({
        filterType,
        filterName,
        loading: false,
      })
    );

    return result;
  };

export const createGlobalTagAction =
  ({ name }) =>
  async (dispatch) => {
    // dispatch(updateFilterLoading({
    //   filterType,
    //   filterName,
    //   loading: true,
    // }))

    const result = await apiCreateGlobalTag({ name });

    // if (result?.data?.id) {
    //   dispatch(updateFilter(result.data))
    // }

    // dispatch(updateFilterLoading({
    //   filterType,
    //   filterName,
    //   loading: false,
    // }))

    return result;
  };
